// ==============================|| MENU ITEMS - NOTIFICATION ROUTES ||============================== //

// icons
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SendIcon from '@mui/icons-material/Send';

const icons = {
  NotificationsActiveIcon,
  SendIcon,
};

const NotiRoutes = {
  id: 'notifications',
  title: 'Notifications',
  type: 'group',
  children: [
    {
      id: 'fcm-list',
      title: 'FCM Device List',
      type: 'item',
      url: '/notifications/devices',
      icon: icons.NotificationsActiveIcon,
      breadcrumbs: false
    }
  ]
};

export default NotiRoutes;